import PropTypes from 'prop-types';
import { FIELDS, FOOTNOTE_DISCLAIMERS_NUMBERS } from '../../../../shared/screener-constants';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import { isModel, shouldShowTicker, mapProductName } from '../../../../utils/sharedHelpers';
import styles from './investment-name.module.scss';

const className = augmentClassName(styles);

const InvestmentName = ({ url, fundName, item }) => {

  const fundType = item[FIELDS.TCFUNDTYPE];
  const fundTicker = item[FIELDS.TCTICKER];
  const productType = item[FIELDS.PRODUCTTYPE];
  const shareClass = item[FIELDS.TCSHARECLASS];

  return (
    <div {...className('investment-name-container')}>
      <div>
        <a
          {...className('investment-name', 'text-decoration-none', 'text-black-blue-hover')}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {fundName}
          {shouldShowTicker(fundType, shareClass) ? `[${fundTicker}]` : ''}
        </a>
      </div>
      <div {...className('pt-3')}>
        <span {...className('product-type')}>
          {mapProductName(productType)}
          {!isModel(fundType) && <sup>{item[FOOTNOTE_DISCLAIMERS_NUMBERS.PRODUCTTYPEDISNUM]}</sup>}
        </span>
        <span {...className('share-class')}>{shareClass}</span>
      </div>
    </div>
  );
};

InvestmentName.propTypes = {
  fundName: PropTypes.string,
  item: PropTypes.object,
  url: PropTypes.string
};

export default InvestmentName;
